// source: evidencemgmt/evidencemgmt.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var attachment_attachment_pb = require('../attachment/attachment_pb.js');
goog.object.extend(proto, attachment_attachment_pb);
var model_control_pb = require('../model/control_pb.js');
goog.object.extend(proto, model_control_pb);
goog.exportSymbol('proto.evidencemgmt.ControlFilter', null, global);
goog.exportSymbol('proto.evidencemgmt.ControlToEvidenceMapping', null, global);
goog.exportSymbol('proto.evidencemgmt.ControlToEvidenceMappingInfo', null, global);
goog.exportSymbol('proto.evidencemgmt.EvidenceFilter', null, global);
goog.exportSymbol('proto.evidencemgmt.EvidenceToControlMapping', null, global);
goog.exportSymbol('proto.evidencemgmt.EvidenceToControlMappingInfo', null, global);
goog.exportSymbol('proto.evidencemgmt.GapEvidenceMapping', null, global);
goog.exportSymbol('proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest', null, global);
goog.exportSymbol('proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse', null, global);
goog.exportSymbol('proto.evidencemgmt.GetControlToEvidenceMappingsRequest', null, global);
goog.exportSymbol('proto.evidencemgmt.GetControlToEvidenceMappingsResponse', null, global);
goog.exportSymbol('proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest', null, global);
goog.exportSymbol('proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse', null, global);
goog.exportSymbol('proto.evidencemgmt.GetEvidenceToControlMappingsRequest', null, global);
goog.exportSymbol('proto.evidencemgmt.GetEvidenceToControlMappingsResponse', null, global);
goog.exportSymbol('proto.evidencemgmt.GetGapEvidenceMappingsRequest', null, global);
goog.exportSymbol('proto.evidencemgmt.GetGapEvidenceMappingsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.ControlFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.ControlFilter.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.ControlFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.ControlFilter.displayName = 'proto.evidencemgmt.ControlFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.EvidenceFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.EvidenceFilter.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.EvidenceFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.EvidenceFilter.displayName = 'proto.evidencemgmt.EvidenceFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.evidencemgmt.GetControlToEvidenceMappingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetControlToEvidenceMappingsRequest.displayName = 'proto.evidencemgmt.GetControlToEvidenceMappingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.evidencemgmt.GetEvidenceToControlMappingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetEvidenceToControlMappingsRequest.displayName = 'proto.evidencemgmt.GetEvidenceToControlMappingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.ControlToEvidenceMapping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.ControlToEvidenceMapping.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.ControlToEvidenceMapping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.ControlToEvidenceMapping.displayName = 'proto.evidencemgmt.ControlToEvidenceMapping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.ControlToEvidenceMappingInfo.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.ControlToEvidenceMappingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.ControlToEvidenceMappingInfo.displayName = 'proto.evidencemgmt.ControlToEvidenceMappingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.EvidenceToControlMappingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.EvidenceToControlMappingInfo.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.EvidenceToControlMappingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.EvidenceToControlMappingInfo.displayName = 'proto.evidencemgmt.EvidenceToControlMappingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.GetControlToEvidenceMappingsResponse.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.GetControlToEvidenceMappingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetControlToEvidenceMappingsResponse.displayName = 'proto.evidencemgmt.GetControlToEvidenceMappingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.EvidenceToControlMapping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.EvidenceToControlMapping.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.EvidenceToControlMapping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.EvidenceToControlMapping.displayName = 'proto.evidencemgmt.EvidenceToControlMapping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.GetEvidenceToControlMappingsResponse.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.GetEvidenceToControlMappingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetEvidenceToControlMappingsResponse.displayName = 'proto.evidencemgmt.GetEvidenceToControlMappingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GapEvidenceMapping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.GapEvidenceMapping.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.GapEvidenceMapping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GapEvidenceMapping.displayName = 'proto.evidencemgmt.GapEvidenceMapping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.evidencemgmt.GetGapEvidenceMappingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetGapEvidenceMappingsRequest.displayName = 'proto.evidencemgmt.GetGapEvidenceMappingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.GetGapEvidenceMappingsResponse.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.GetGapEvidenceMappingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetGapEvidenceMappingsResponse.displayName = 'proto.evidencemgmt.GetGapEvidenceMappingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.displayName = 'proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.displayName = 'proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.displayName = 'proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.displayName = 'proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.ControlFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.ControlFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.ControlFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.ControlFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.ControlFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.ControlFilter}
 */
proto.evidencemgmt.ControlFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.ControlFilter;
  return proto.evidencemgmt.ControlFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.ControlFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.ControlFilter}
 */
proto.evidencemgmt.ControlFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.ControlFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.ControlFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.ControlFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.ControlFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string control_ids = 1;
 * @return {!Array<string>}
 */
proto.evidencemgmt.ControlFilter.prototype.getControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.evidencemgmt.ControlFilter} returns this
 */
proto.evidencemgmt.ControlFilter.prototype.setControlIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.ControlFilter} returns this
 */
proto.evidencemgmt.ControlFilter.prototype.addControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.ControlFilter} returns this
 */
proto.evidencemgmt.ControlFilter.prototype.clearControlIdsList = function() {
  return this.setControlIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.EvidenceFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.EvidenceFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.EvidenceFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.EvidenceFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.EvidenceFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.EvidenceFilter}
 */
proto.evidencemgmt.EvidenceFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.EvidenceFilter;
  return proto.evidencemgmt.EvidenceFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.EvidenceFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.EvidenceFilter}
 */
proto.evidencemgmt.EvidenceFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvidenceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.EvidenceFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.EvidenceFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.EvidenceFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.EvidenceFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string evidence_ids = 1;
 * @return {!Array<string>}
 */
proto.evidencemgmt.EvidenceFilter.prototype.getEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.evidencemgmt.EvidenceFilter} returns this
 */
proto.evidencemgmt.EvidenceFilter.prototype.setEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.EvidenceFilter} returns this
 */
proto.evidencemgmt.EvidenceFilter.prototype.addEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.EvidenceFilter} returns this
 */
proto.evidencemgmt.EvidenceFilter.prototype.clearEvidenceIdsList = function() {
  return this.setEvidenceIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetControlToEvidenceMappingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlFilter: (f = msg.getControlFilter()) && proto.evidencemgmt.ControlFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetControlToEvidenceMappingsRequest;
  return proto.evidencemgmt.GetControlToEvidenceMappingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.ControlFilter;
      reader.readMessage(value,proto.evidencemgmt.ControlFilter.deserializeBinaryFromReader);
      msg.setControlFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetControlToEvidenceMappingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.evidencemgmt.ControlFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional ControlFilter control_filter = 1;
 * @return {?proto.evidencemgmt.ControlFilter}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.prototype.getControlFilter = function() {
  return /** @type{?proto.evidencemgmt.ControlFilter} */ (
    jspb.Message.getWrapperField(this, proto.evidencemgmt.ControlFilter, 1));
};


/**
 * @param {?proto.evidencemgmt.ControlFilter|undefined} value
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} returns this
*/
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.prototype.setControlFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsRequest} returns this
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.prototype.clearControlFilter = function() {
  return this.setControlFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsRequest.prototype.hasControlFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetEvidenceToControlMappingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceFilter: (f = msg.getEvidenceFilter()) && proto.evidencemgmt.EvidenceFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetEvidenceToControlMappingsRequest;
  return proto.evidencemgmt.GetEvidenceToControlMappingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.EvidenceFilter;
      reader.readMessage(value,proto.evidencemgmt.EvidenceFilter.deserializeBinaryFromReader);
      msg.setEvidenceFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetEvidenceToControlMappingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.evidencemgmt.EvidenceFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceFilter evidence_filter = 1;
 * @return {?proto.evidencemgmt.EvidenceFilter}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.prototype.getEvidenceFilter = function() {
  return /** @type{?proto.evidencemgmt.EvidenceFilter} */ (
    jspb.Message.getWrapperField(this, proto.evidencemgmt.EvidenceFilter, 1));
};


/**
 * @param {?proto.evidencemgmt.EvidenceFilter|undefined} value
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} returns this
*/
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.prototype.setEvidenceFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsRequest} returns this
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.prototype.clearEvidenceFilter = function() {
  return this.setEvidenceFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsRequest.prototype.hasEvidenceFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.ControlToEvidenceMapping.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.ControlToEvidenceMapping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.ControlToEvidenceMapping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.ControlToEvidenceMapping.toObject = function(includeInstance, msg) {
  var f, obj = {
    control: (f = msg.getControl()) && model_control_pb.Control.toObject(includeInstance, f),
    evidenceList: jspb.Message.toObjectList(msg.getEvidenceList(),
    attachment_attachment_pb.EvidenceGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.ControlToEvidenceMapping}
 */
proto.evidencemgmt.ControlToEvidenceMapping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.ControlToEvidenceMapping;
  return proto.evidencemgmt.ControlToEvidenceMapping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.ControlToEvidenceMapping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.ControlToEvidenceMapping}
 */
proto.evidencemgmt.ControlToEvidenceMapping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new model_control_pb.Control;
      reader.readMessage(value,model_control_pb.Control.deserializeBinaryFromReader);
      msg.setControl(value);
      break;
    case 2:
      var value = new attachment_attachment_pb.EvidenceGroup;
      reader.readMessage(value,attachment_attachment_pb.EvidenceGroup.deserializeBinaryFromReader);
      msg.addEvidence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.ControlToEvidenceMapping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.ControlToEvidenceMapping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.ControlToEvidenceMapping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControl();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      model_control_pb.Control.serializeBinaryToWriter
    );
  }
  f = message.getEvidenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      attachment_attachment_pb.EvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional model.Control control = 1;
 * @return {?proto.model.Control}
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.getControl = function() {
  return /** @type{?proto.model.Control} */ (
    jspb.Message.getWrapperField(this, model_control_pb.Control, 1));
};


/**
 * @param {?proto.model.Control|undefined} value
 * @return {!proto.evidencemgmt.ControlToEvidenceMapping} returns this
*/
proto.evidencemgmt.ControlToEvidenceMapping.prototype.setControl = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.ControlToEvidenceMapping} returns this
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.clearControl = function() {
  return this.setControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.hasControl = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated attachment.EvidenceGroup evidence = 2;
 * @return {!Array<!proto.attachment.EvidenceGroup>}
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.getEvidenceList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, attachment_attachment_pb.EvidenceGroup, 2));
};


/**
 * @param {!Array<!proto.attachment.EvidenceGroup>} value
 * @return {!proto.evidencemgmt.ControlToEvidenceMapping} returns this
*/
proto.evidencemgmt.ControlToEvidenceMapping.prototype.setEvidenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.attachment.EvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.addEvidence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.attachment.EvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.ControlToEvidenceMapping} returns this
 */
proto.evidencemgmt.ControlToEvidenceMapping.prototype.clearEvidenceList = function() {
  return this.setEvidenceList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.repeatedFields_ = [2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.ControlToEvidenceMappingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.ControlToEvidenceMappingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    control: (f = msg.getControl()) && model_control_pb.Control.toObject(includeInstance, f),
    gapEvidenceMappingsList: jspb.Message.toObjectList(msg.getGapEvidenceMappingsList(),
    proto.evidencemgmt.GapEvidenceMapping.toObject, includeInstance),
    linkedEvidenceList: jspb.Message.toObjectList(msg.getLinkedEvidenceList(),
    attachment_attachment_pb.EvidenceGroup.toObject, includeInstance),
    suggestedEvidenceList: jspb.Message.toObjectList(msg.getSuggestedEvidenceList(),
    attachment_attachment_pb.EvidenceGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.ControlToEvidenceMappingInfo;
  return proto.evidencemgmt.ControlToEvidenceMappingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.ControlToEvidenceMappingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new model_control_pb.Control;
      reader.readMessage(value,model_control_pb.Control.deserializeBinaryFromReader);
      msg.setControl(value);
      break;
    case 2:
      var value = new proto.evidencemgmt.GapEvidenceMapping;
      reader.readMessage(value,proto.evidencemgmt.GapEvidenceMapping.deserializeBinaryFromReader);
      msg.addGapEvidenceMappings(value);
      break;
    case 3:
      var value = new attachment_attachment_pb.EvidenceGroup;
      reader.readMessage(value,attachment_attachment_pb.EvidenceGroup.deserializeBinaryFromReader);
      msg.addLinkedEvidence(value);
      break;
    case 4:
      var value = new attachment_attachment_pb.EvidenceGroup;
      reader.readMessage(value,attachment_attachment_pb.EvidenceGroup.deserializeBinaryFromReader);
      msg.addSuggestedEvidence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.ControlToEvidenceMappingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.ControlToEvidenceMappingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControl();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      model_control_pb.Control.serializeBinaryToWriter
    );
  }
  f = message.getGapEvidenceMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.evidencemgmt.GapEvidenceMapping.serializeBinaryToWriter
    );
  }
  f = message.getLinkedEvidenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      attachment_attachment_pb.EvidenceGroup.serializeBinaryToWriter
    );
  }
  f = message.getSuggestedEvidenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      attachment_attachment_pb.EvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional model.Control control = 1;
 * @return {?proto.model.Control}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.getControl = function() {
  return /** @type{?proto.model.Control} */ (
    jspb.Message.getWrapperField(this, model_control_pb.Control, 1));
};


/**
 * @param {?proto.model.Control|undefined} value
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
*/
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.setControl = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.clearControl = function() {
  return this.setControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.hasControl = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated GapEvidenceMapping gap_evidence_mappings = 2;
 * @return {!Array<!proto.evidencemgmt.GapEvidenceMapping>}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.getGapEvidenceMappingsList = function() {
  return /** @type{!Array<!proto.evidencemgmt.GapEvidenceMapping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.evidencemgmt.GapEvidenceMapping, 2));
};


/**
 * @param {!Array<!proto.evidencemgmt.GapEvidenceMapping>} value
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
*/
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.setGapEvidenceMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.evidencemgmt.GapEvidenceMapping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.GapEvidenceMapping}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.addGapEvidenceMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.evidencemgmt.GapEvidenceMapping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.clearGapEvidenceMappingsList = function() {
  return this.setGapEvidenceMappingsList([]);
};


/**
 * repeated attachment.EvidenceGroup linked_evidence = 3;
 * @return {!Array<!proto.attachment.EvidenceGroup>}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.getLinkedEvidenceList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, attachment_attachment_pb.EvidenceGroup, 3));
};


/**
 * @param {!Array<!proto.attachment.EvidenceGroup>} value
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
*/
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.setLinkedEvidenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.attachment.EvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.addLinkedEvidence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.attachment.EvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.clearLinkedEvidenceList = function() {
  return this.setLinkedEvidenceList([]);
};


/**
 * repeated attachment.EvidenceGroup suggested_evidence = 4;
 * @return {!Array<!proto.attachment.EvidenceGroup>}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.getSuggestedEvidenceList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, attachment_attachment_pb.EvidenceGroup, 4));
};


/**
 * @param {!Array<!proto.attachment.EvidenceGroup>} value
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
*/
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.setSuggestedEvidenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.attachment.EvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.addSuggestedEvidence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.attachment.EvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo} returns this
 */
proto.evidencemgmt.ControlToEvidenceMappingInfo.prototype.clearSuggestedEvidenceList = function() {
  return this.setSuggestedEvidenceList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.EvidenceToControlMappingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.EvidenceToControlMappingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidence: (f = msg.getEvidence()) && attachment_attachment_pb.EvidenceGroup.toObject(includeInstance, f),
    linkedControlsList: jspb.Message.toObjectList(msg.getLinkedControlsList(),
    model_control_pb.Control.toObject, includeInstance),
    suggestedControlsList: jspb.Message.toObjectList(msg.getSuggestedControlsList(),
    model_control_pb.Control.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.EvidenceToControlMappingInfo;
  return proto.evidencemgmt.EvidenceToControlMappingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.EvidenceToControlMappingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new attachment_attachment_pb.EvidenceGroup;
      reader.readMessage(value,attachment_attachment_pb.EvidenceGroup.deserializeBinaryFromReader);
      msg.setEvidence(value);
      break;
    case 2:
      var value = new model_control_pb.Control;
      reader.readMessage(value,model_control_pb.Control.deserializeBinaryFromReader);
      msg.addLinkedControls(value);
      break;
    case 3:
      var value = new model_control_pb.Control;
      reader.readMessage(value,model_control_pb.Control.deserializeBinaryFromReader);
      msg.addSuggestedControls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.EvidenceToControlMappingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.EvidenceToControlMappingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidence();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      attachment_attachment_pb.EvidenceGroup.serializeBinaryToWriter
    );
  }
  f = message.getLinkedControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      model_control_pb.Control.serializeBinaryToWriter
    );
  }
  f = message.getSuggestedControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      model_control_pb.Control.serializeBinaryToWriter
    );
  }
};


/**
 * optional attachment.EvidenceGroup evidence = 1;
 * @return {?proto.attachment.EvidenceGroup}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.getEvidence = function() {
  return /** @type{?proto.attachment.EvidenceGroup} */ (
    jspb.Message.getWrapperField(this, attachment_attachment_pb.EvidenceGroup, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroup|undefined} value
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo} returns this
*/
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.setEvidence = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo} returns this
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.clearEvidence = function() {
  return this.setEvidence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.hasEvidence = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated model.Control linked_controls = 2;
 * @return {!Array<!proto.model.Control>}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.getLinkedControlsList = function() {
  return /** @type{!Array<!proto.model.Control>} */ (
    jspb.Message.getRepeatedWrapperField(this, model_control_pb.Control, 2));
};


/**
 * @param {!Array<!proto.model.Control>} value
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo} returns this
*/
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.setLinkedControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.model.Control=} opt_value
 * @param {number=} opt_index
 * @return {!proto.model.Control}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.addLinkedControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.model.Control, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo} returns this
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.clearLinkedControlsList = function() {
  return this.setLinkedControlsList([]);
};


/**
 * repeated model.Control suggested_controls = 3;
 * @return {!Array<!proto.model.Control>}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.getSuggestedControlsList = function() {
  return /** @type{!Array<!proto.model.Control>} */ (
    jspb.Message.getRepeatedWrapperField(this, model_control_pb.Control, 3));
};


/**
 * @param {!Array<!proto.model.Control>} value
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo} returns this
*/
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.setSuggestedControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.model.Control=} opt_value
 * @param {number=} opt_index
 * @return {!proto.model.Control}
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.addSuggestedControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.model.Control, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo} returns this
 */
proto.evidencemgmt.EvidenceToControlMappingInfo.prototype.clearSuggestedControlsList = function() {
  return this.setSuggestedControlsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetControlToEvidenceMappingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlToEvidenceMappingsList: jspb.Message.toObjectList(msg.getControlToEvidenceMappingsList(),
    proto.evidencemgmt.ControlToEvidenceMapping.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsResponse}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetControlToEvidenceMappingsResponse;
  return proto.evidencemgmt.GetControlToEvidenceMappingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsResponse}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.ControlToEvidenceMapping;
      reader.readMessage(value,proto.evidencemgmt.ControlToEvidenceMapping.deserializeBinaryFromReader);
      msg.addControlToEvidenceMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetControlToEvidenceMappingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlToEvidenceMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.evidencemgmt.ControlToEvidenceMapping.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ControlToEvidenceMapping control_to_evidence_mappings = 1;
 * @return {!Array<!proto.evidencemgmt.ControlToEvidenceMapping>}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.prototype.getControlToEvidenceMappingsList = function() {
  return /** @type{!Array<!proto.evidencemgmt.ControlToEvidenceMapping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.evidencemgmt.ControlToEvidenceMapping, 1));
};


/**
 * @param {!Array<!proto.evidencemgmt.ControlToEvidenceMapping>} value
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsResponse} returns this
*/
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.prototype.setControlToEvidenceMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.evidencemgmt.ControlToEvidenceMapping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.ControlToEvidenceMapping}
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.prototype.addControlToEvidenceMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.evidencemgmt.ControlToEvidenceMapping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingsResponse} returns this
 */
proto.evidencemgmt.GetControlToEvidenceMappingsResponse.prototype.clearControlToEvidenceMappingsList = function() {
  return this.setControlToEvidenceMappingsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.EvidenceToControlMapping.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.EvidenceToControlMapping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.EvidenceToControlMapping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.EvidenceToControlMapping.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidence: (f = msg.getEvidence()) && attachment_attachment_pb.EvidenceGroup.toObject(includeInstance, f),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    model_control_pb.Control.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.EvidenceToControlMapping}
 */
proto.evidencemgmt.EvidenceToControlMapping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.EvidenceToControlMapping;
  return proto.evidencemgmt.EvidenceToControlMapping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.EvidenceToControlMapping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.EvidenceToControlMapping}
 */
proto.evidencemgmt.EvidenceToControlMapping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new attachment_attachment_pb.EvidenceGroup;
      reader.readMessage(value,attachment_attachment_pb.EvidenceGroup.deserializeBinaryFromReader);
      msg.setEvidence(value);
      break;
    case 2:
      var value = new model_control_pb.Control;
      reader.readMessage(value,model_control_pb.Control.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.EvidenceToControlMapping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.EvidenceToControlMapping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.EvidenceToControlMapping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidence();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      attachment_attachment_pb.EvidenceGroup.serializeBinaryToWriter
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      model_control_pb.Control.serializeBinaryToWriter
    );
  }
};


/**
 * optional attachment.EvidenceGroup evidence = 1;
 * @return {?proto.attachment.EvidenceGroup}
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.getEvidence = function() {
  return /** @type{?proto.attachment.EvidenceGroup} */ (
    jspb.Message.getWrapperField(this, attachment_attachment_pb.EvidenceGroup, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroup|undefined} value
 * @return {!proto.evidencemgmt.EvidenceToControlMapping} returns this
*/
proto.evidencemgmt.EvidenceToControlMapping.prototype.setEvidence = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.EvidenceToControlMapping} returns this
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.clearEvidence = function() {
  return this.setEvidence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.hasEvidence = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated model.Control controls = 2;
 * @return {!Array<!proto.model.Control>}
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.model.Control>} */ (
    jspb.Message.getRepeatedWrapperField(this, model_control_pb.Control, 2));
};


/**
 * @param {!Array<!proto.model.Control>} value
 * @return {!proto.evidencemgmt.EvidenceToControlMapping} returns this
*/
proto.evidencemgmt.EvidenceToControlMapping.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.model.Control=} opt_value
 * @param {number=} opt_index
 * @return {!proto.model.Control}
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.model.Control, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.EvidenceToControlMapping} returns this
 */
proto.evidencemgmt.EvidenceToControlMapping.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetEvidenceToControlMappingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceControlMappingsList: jspb.Message.toObjectList(msg.getEvidenceControlMappingsList(),
    proto.evidencemgmt.EvidenceToControlMapping.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsResponse}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetEvidenceToControlMappingsResponse;
  return proto.evidencemgmt.GetEvidenceToControlMappingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsResponse}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.EvidenceToControlMapping;
      reader.readMessage(value,proto.evidencemgmt.EvidenceToControlMapping.deserializeBinaryFromReader);
      msg.addEvidenceControlMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetEvidenceToControlMappingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceControlMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.evidencemgmt.EvidenceToControlMapping.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EvidenceToControlMapping evidence_control_mappings = 1;
 * @return {!Array<!proto.evidencemgmt.EvidenceToControlMapping>}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.prototype.getEvidenceControlMappingsList = function() {
  return /** @type{!Array<!proto.evidencemgmt.EvidenceToControlMapping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.evidencemgmt.EvidenceToControlMapping, 1));
};


/**
 * @param {!Array<!proto.evidencemgmt.EvidenceToControlMapping>} value
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsResponse} returns this
*/
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.prototype.setEvidenceControlMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.evidencemgmt.EvidenceToControlMapping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.EvidenceToControlMapping}
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.prototype.addEvidenceControlMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.evidencemgmt.EvidenceToControlMapping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingsResponse} returns this
 */
proto.evidencemgmt.GetEvidenceToControlMappingsResponse.prototype.clearEvidenceControlMappingsList = function() {
  return this.setEvidenceControlMappingsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.GapEvidenceMapping.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GapEvidenceMapping.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GapEvidenceMapping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GapEvidenceMapping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GapEvidenceMapping.toObject = function(includeInstance, msg) {
  var f, obj = {
    gap: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evidencesList: jspb.Message.toObjectList(msg.getEvidencesList(),
    attachment_attachment_pb.EvidenceGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GapEvidenceMapping}
 */
proto.evidencemgmt.GapEvidenceMapping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GapEvidenceMapping;
  return proto.evidencemgmt.GapEvidenceMapping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GapEvidenceMapping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GapEvidenceMapping}
 */
proto.evidencemgmt.GapEvidenceMapping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGap(value);
      break;
    case 2:
      var value = new attachment_attachment_pb.EvidenceGroup;
      reader.readMessage(value,attachment_attachment_pb.EvidenceGroup.deserializeBinaryFromReader);
      msg.addEvidences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GapEvidenceMapping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GapEvidenceMapping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GapEvidenceMapping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GapEvidenceMapping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGap();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvidencesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      attachment_attachment_pb.EvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional string gap = 1;
 * @return {string}
 */
proto.evidencemgmt.GapEvidenceMapping.prototype.getGap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.evidencemgmt.GapEvidenceMapping} returns this
 */
proto.evidencemgmt.GapEvidenceMapping.prototype.setGap = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated attachment.EvidenceGroup evidences = 2;
 * @return {!Array<!proto.attachment.EvidenceGroup>}
 */
proto.evidencemgmt.GapEvidenceMapping.prototype.getEvidencesList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, attachment_attachment_pb.EvidenceGroup, 2));
};


/**
 * @param {!Array<!proto.attachment.EvidenceGroup>} value
 * @return {!proto.evidencemgmt.GapEvidenceMapping} returns this
*/
proto.evidencemgmt.GapEvidenceMapping.prototype.setEvidencesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.attachment.EvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.evidencemgmt.GapEvidenceMapping.prototype.addEvidences = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.attachment.EvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.GapEvidenceMapping} returns this
 */
proto.evidencemgmt.GapEvidenceMapping.prototype.clearEvidencesList = function() {
  return this.setEvidencesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetGapEvidenceMappingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlFilter: (f = msg.getControlFilter()) && proto.evidencemgmt.ControlFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsRequest}
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetGapEvidenceMappingsRequest;
  return proto.evidencemgmt.GetGapEvidenceMappingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsRequest}
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.ControlFilter;
      reader.readMessage(value,proto.evidencemgmt.ControlFilter.deserializeBinaryFromReader);
      msg.setControlFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetGapEvidenceMappingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.evidencemgmt.ControlFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional ControlFilter control_filter = 1;
 * @return {?proto.evidencemgmt.ControlFilter}
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.prototype.getControlFilter = function() {
  return /** @type{?proto.evidencemgmt.ControlFilter} */ (
    jspb.Message.getWrapperField(this, proto.evidencemgmt.ControlFilter, 1));
};


/**
 * @param {?proto.evidencemgmt.ControlFilter|undefined} value
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} returns this
*/
proto.evidencemgmt.GetGapEvidenceMappingsRequest.prototype.setControlFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsRequest} returns this
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.prototype.clearControlFilter = function() {
  return this.setControlFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.GetGapEvidenceMappingsRequest.prototype.hasControlFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetGapEvidenceMappingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    gapEvidenceMappingsList: jspb.Message.toObjectList(msg.getGapEvidenceMappingsList(),
    proto.evidencemgmt.GapEvidenceMapping.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsResponse}
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetGapEvidenceMappingsResponse;
  return proto.evidencemgmt.GetGapEvidenceMappingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsResponse}
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.GapEvidenceMapping;
      reader.readMessage(value,proto.evidencemgmt.GapEvidenceMapping.deserializeBinaryFromReader);
      msg.addGapEvidenceMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetGapEvidenceMappingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetGapEvidenceMappingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGapEvidenceMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.evidencemgmt.GapEvidenceMapping.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GapEvidenceMapping gap_evidence_mappings = 1;
 * @return {!Array<!proto.evidencemgmt.GapEvidenceMapping>}
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.prototype.getGapEvidenceMappingsList = function() {
  return /** @type{!Array<!proto.evidencemgmt.GapEvidenceMapping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.evidencemgmt.GapEvidenceMapping, 1));
};


/**
 * @param {!Array<!proto.evidencemgmt.GapEvidenceMapping>} value
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsResponse} returns this
*/
proto.evidencemgmt.GetGapEvidenceMappingsResponse.prototype.setGapEvidenceMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.evidencemgmt.GapEvidenceMapping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.GapEvidenceMapping}
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.prototype.addGapEvidenceMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.evidencemgmt.GapEvidenceMapping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.GetGapEvidenceMappingsResponse} returns this
 */
proto.evidencemgmt.GetGapEvidenceMappingsResponse.prototype.clearGapEvidenceMappingsList = function() {
  return this.setGapEvidenceMappingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlFilter: (f = msg.getControlFilter()) && proto.evidencemgmt.ControlFilter.toObject(includeInstance, f),
    defaultToAll: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest;
  return proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.ControlFilter;
      reader.readMessage(value,proto.evidencemgmt.ControlFilter.deserializeBinaryFromReader);
      msg.setControlFilter(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefaultToAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.evidencemgmt.ControlFilter.serializeBinaryToWriter
    );
  }
  f = message.getDefaultToAll();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional ControlFilter control_filter = 1;
 * @return {?proto.evidencemgmt.ControlFilter}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.getControlFilter = function() {
  return /** @type{?proto.evidencemgmt.ControlFilter} */ (
    jspb.Message.getWrapperField(this, proto.evidencemgmt.ControlFilter, 1));
};


/**
 * @param {?proto.evidencemgmt.ControlFilter|undefined} value
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} returns this
*/
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.setControlFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} returns this
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.clearControlFilter = function() {
  return this.setControlFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.hasControlFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool default_to_all = 2;
 * @return {boolean}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.getDefaultToAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest} returns this
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoRequest.prototype.setDefaultToAll = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlEvidenceMappingsList: jspb.Message.toObjectList(msg.getControlEvidenceMappingsList(),
    proto.evidencemgmt.ControlToEvidenceMappingInfo.toObject, includeInstance),
    isIndexing: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse;
  return proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.ControlToEvidenceMappingInfo;
      reader.readMessage(value,proto.evidencemgmt.ControlToEvidenceMappingInfo.deserializeBinaryFromReader);
      msg.addControlEvidenceMappings(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsIndexing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlEvidenceMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.evidencemgmt.ControlToEvidenceMappingInfo.serializeBinaryToWriter
    );
  }
  f = message.getIsIndexing();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated ControlToEvidenceMappingInfo control_evidence_mappings = 1;
 * @return {!Array<!proto.evidencemgmt.ControlToEvidenceMappingInfo>}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.getControlEvidenceMappingsList = function() {
  return /** @type{!Array<!proto.evidencemgmt.ControlToEvidenceMappingInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.evidencemgmt.ControlToEvidenceMappingInfo, 1));
};


/**
 * @param {!Array<!proto.evidencemgmt.ControlToEvidenceMappingInfo>} value
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse} returns this
*/
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.setControlEvidenceMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.evidencemgmt.ControlToEvidenceMappingInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.ControlToEvidenceMappingInfo}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.addControlEvidenceMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.evidencemgmt.ControlToEvidenceMappingInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse} returns this
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.clearControlEvidenceMappingsList = function() {
  return this.setControlEvidenceMappingsList([]);
};


/**
 * optional bool is_indexing = 2;
 * @return {boolean}
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.getIsIndexing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse} returns this
 */
proto.evidencemgmt.GetControlToEvidenceMappingInfoResponse.prototype.setIsIndexing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceFilter: (f = msg.getEvidenceFilter()) && proto.evidencemgmt.EvidenceFilter.toObject(includeInstance, f),
    defaultToAll: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest;
  return proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.EvidenceFilter;
      reader.readMessage(value,proto.evidencemgmt.EvidenceFilter.deserializeBinaryFromReader);
      msg.setEvidenceFilter(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefaultToAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.evidencemgmt.EvidenceFilter.serializeBinaryToWriter
    );
  }
  f = message.getDefaultToAll();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional EvidenceFilter evidence_filter = 1;
 * @return {?proto.evidencemgmt.EvidenceFilter}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.getEvidenceFilter = function() {
  return /** @type{?proto.evidencemgmt.EvidenceFilter} */ (
    jspb.Message.getWrapperField(this, proto.evidencemgmt.EvidenceFilter, 1));
};


/**
 * @param {?proto.evidencemgmt.EvidenceFilter|undefined} value
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} returns this
*/
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.setEvidenceFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} returns this
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.clearEvidenceFilter = function() {
  return this.setEvidenceFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.hasEvidenceFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool default_to_all = 2;
 * @return {boolean}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.getDefaultToAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest} returns this
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoRequest.prototype.setDefaultToAll = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceControlMappingsList: jspb.Message.toObjectList(msg.getEvidenceControlMappingsList(),
    proto.evidencemgmt.EvidenceToControlMappingInfo.toObject, includeInstance),
    isIndexing: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse;
  return proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.evidencemgmt.EvidenceToControlMappingInfo;
      reader.readMessage(value,proto.evidencemgmt.EvidenceToControlMappingInfo.deserializeBinaryFromReader);
      msg.addEvidenceControlMappings(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsIndexing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceControlMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.evidencemgmt.EvidenceToControlMappingInfo.serializeBinaryToWriter
    );
  }
  f = message.getIsIndexing();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated EvidenceToControlMappingInfo evidence_control_mappings = 1;
 * @return {!Array<!proto.evidencemgmt.EvidenceToControlMappingInfo>}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.getEvidenceControlMappingsList = function() {
  return /** @type{!Array<!proto.evidencemgmt.EvidenceToControlMappingInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.evidencemgmt.EvidenceToControlMappingInfo, 1));
};


/**
 * @param {!Array<!proto.evidencemgmt.EvidenceToControlMappingInfo>} value
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse} returns this
*/
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.setEvidenceControlMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.evidencemgmt.EvidenceToControlMappingInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.evidencemgmt.EvidenceToControlMappingInfo}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.addEvidenceControlMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.evidencemgmt.EvidenceToControlMappingInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse} returns this
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.clearEvidenceControlMappingsList = function() {
  return this.setEvidenceControlMappingsList([]);
};


/**
 * optional bool is_indexing = 2;
 * @return {boolean}
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.getIsIndexing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse} returns this
 */
proto.evidencemgmt.GetEvidenceToControlMappingInfoResponse.prototype.setIsIndexing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.evidencemgmt);
